import { Link } from 'react-router-dom';
import { breadcrumbMap } from '@/mocks/shows';

interface BreadcrumbProps {
  items: { label: string; href?: string }[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-600">
        <li>
          <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">
            <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </li>
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-1">
            <span className="text-foreground-300">/</span>
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-950 font-medium whitespace-nowrap">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export { breadcrumbMap };